import { AppIcon } from "./AppIcon";

export function SettingsIcon() {
  return <AppIcon name="settings" className="topbar__btn-svg" />;
}
